<template>
    <el-dialog :visible.sync="dialogVisible" width="95%">
        <div class="opinion">
            <div class="header bm bm-ac bm-pj">
                <div class="title">下为<span>「{{proName}}」</span>的所选产品的价格制定默认预算值，如有预算意见请修改</div>
                <div class="opinionBtn bm bm-ac">
                    <el-button plain @click="close(0)">取消</el-button>
                    <el-button type="primary" @click="close(1)">保存</el-button>
                </div>
            </div>
            <div class="filter bm bm-ac">
                <div class="filterTitle">产品类型</div>
                <el-select v-model="productType" placeholder="请选择" size="small" @change="changeType">
                    <el-option v-for="item in productOptions" :key="item.value" :label="item.name" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <el-table border height="100%" v-loading="loading" :key="tableKey" :data="opinionData" :cell-class-name="tableCellClassName" @cell-click="celledit" align="center" style="width: 100%"
                    :header-cell-style="{color: '#323232','font-size': '14px','background-color': '#ffffff',height: '34px','border-right': '1px solid #ebeef5'}" ref="table">
                    <multi-type-column v-for="(item, index) in tableHead" :key="index" :col="item" :required="true" :editField="editField" :editFildHide="editFildHide" :editFieldType="editFieldType" :formatterList="formatterList"
                        @loseFocus="loseFocus">
                    </multi-type-column>
                </el-table>
    </el-dialog>
</template>

<script>
import { salesApi} from "@/services";
export default {
    name: "price-budget-opinion",
    data() {
        return {
            dialogVisible: false,
            loading:true,
            productType: "", //选中的产品类型
            // 产品类型
            productOptions: [
                {
                    name: "全部产品",
                    value: ""
                },
                {
                    name: "未上市新品",
                    value: "0"
                },
                {
                    name: "已上市产品",
                    value: "1"
                }
            ],

             completeFlag: this.$store.state.init.initData.completeFlag, //不等于0，1操作要禁用的就禁用掉
             tableKey: 0,
             tableDataOpinion:[],
             editField: ["adviseStartExecDate", "adviseBidPrice"],
             editFildHide:["adviseStartExecDate"],
             editFieldType: ["date", "text"],
             formatterList: [
                "startExecDate",
                "adviseStartExecDate",
                "invoicePriceStartExecDate"
            ],
            tableHead: [
                {
                    prop: "materialName",
                    label: "产品名称",
                    fixed: "left",
                    width:"100"
                },
                {
                    prop: "materialCode",
                    label: "产品编码",
                },
                {
                    prop: "baseMeasureUnit",
                    label: "单位"
                },
                {
                    prop: "provinceName",
                    label: "省份",
                },
                {
                    prop: "sfSales",
                    label: "是否上市",
                },
                {
                    prop: "",
                    label: "中标价-投标管理部意见",
                    isShowTip: true,
                    children: [
                        {
                            prop: "startExecDate",
                            label: "预计执行时间",
                            width: "140px"
                        },
                        {
                            prop: "bidPrice",
                            label: "预计中标价(元)",
                            width: "140px"
                        }
                    ]
                },
                {
                    prop: "",
                    label: "中标价-纯销意见",
                    children: [
                        {
                            prop: "adviseStartExecDate",
                            label: "预计执行时间",
                            width: "140px"
                        },
                        {
                            prop: "adviseBidPrice",
                            label: "预计中标价(元)",
                            width: "140px"
                        }
                    ]
                },
                {
                    prop: "",
                    label: "预计开票价-渠道意见",
                    children: [
                        {
                            prop: "invoicePriceDownRatio",
                            label: "开票价下浮比例(%)",
                            width: "160px"
                        },
                        {
                            prop: "invoicePrice",
                            label: "预计开票价(元)",
                            width: "140px"
                        },
                        {
                            prop: "invoicePriceStartExecDate",
                            label: "预计执行时间",
                            width: "140px"
                        }
                    ]
                },
                {
                    prop:"",
                    label:"去税/扣减折扣/-预算-纯销意见",
                    children:[
                        {
                            prop: "taxlessInvoicePrice",
                            label: "无税开票价(元)",
                            width: "140px"
                        },
                        {
                            prop: "comprehensiveDiscountRatio",
                            label: "综合折扣比例(%)",
                            width: "160px"
                        }, 
                        {
                            prop: "priceAfterDiscount",
                            label: "综合折扣后价格",
                            width: "140px"
                        }
                    ]
                }
            ],
            proName:"",//当前查询的省份
            discountRatioList:"",//综合折扣
            // 税率入参
            paramTax:{
                "fillYear":new Date().getFullYear(),
                "dataVersion":this.$store.state.init.initData.dataVersion
            },
            taxList:[],//税率
            developDepartPredictBidPrice:[],//销售-价格-公发部预算中标价列表
            channelInvoicePriceDownRatio:[],//销售-价格-渠道开票价下浮比例列表
            // 填报保存入参
            addParam: {
                "configurationId": this.$store.state.init.initData.configurationId,//报表id
                "completeFlag": 1,//填报状态标识 1:暂存，2：发布
                "list":this.opinionData
            },
        };
    },
    props: {
        visible: {
            type: Boolean
        },
        province:{
            type: Array
        },
        opinionData:{
            type:Array
        },
    },
    watch: {
        province: {
            immediate: false, //首次绑定，是否执行
            handler(arr) {
                if(arr.length>1){
                    let nameStr=""
                    arr.forEach(item=>{
                        nameStr+=`${item.provinceName}、`
                    })
                    this.proName=nameStr.substring(0,nameStr.length-1)
                }else{
                    this.proName=arr[0].provinceName
                }
            }
        },
        visible: {
            immediate: true, //首次绑定，是否执行
            handler(status) {
                this.dialogVisible = status;
            }
        },
        opinionData: {
            immediate: false, //首次绑定，是否执行
            handler(arr) {
                this.loading=false
                // if(this.$refs.table.$el.children[1].children[0].children[1].children[0].children[6].offsetLeft){
                //     // 相对偏移值
                //     let leftWidth1=this.$refs.table.$el.children[1].children[0].children[1].children[0].children[5].offsetLeft+100;
                //     this.$refs.tipsBox.style.cssText=`left:${leftWidth1}px`
                //     this.tipsStatus=true

                //     // 提示框水平滚动距离
                //     this.dom = this.$refs.table.bodyWrapper
                //     this.dom.addEventListener('scroll', () => {
                //         // 滚动距离
                //         let leftWidth2=this.dom.scrollLeft
                //         if(leftWidth1-leftWidth2<400){
                //             this.tipsStatus=false
                //         }else{
                //             this.tipsStatus=true
                //         }
                //         this.$refs.tipsBox.style.cssText=`left:${leftWidth1-leftWidth2}px`
                //     })
                // }   
                
            }
        },
    },
 
    created(){
        // 综合折扣        
        this.discountRatioList = parseFloat((this.$store.state.init.configInfo.discountRatioList[0].name*100).toPrecision(12));
        // 税率
        salesApi.taxList(this.paramTax).then(res => {
            this.taxList = res.responseData;  
        });
        // 销售-价格-公发部预算中标价列表
        salesApi.getDevelopDepartPredictBidPrice({"fillYear":new Date().getFullYear(),"marketQuery":"0"}).then(res => {
            this.developDepartPredictBidPrice = res.responseData;  
        });
        // 销售-价格-渠道开票价下浮比例列表
        salesApi.getChannelInvoicePriceDownRatio({"fillYear":new Date().getFullYear(),"dataVersion":this.$store.state.init.initData.dataVersion,"marketQuery":"0"}).then(res => {
            this.channelInvoicePriceDownRatio = res.responseData;  
        });
        
        //计算属性之间的关系
        // 预计开票价 = 预计中标价 * (1 - 开票价下浮比例)
        // 无税开票价 = 预计开票价 / (1 + 预计税率或预算税率)
        // 综合折扣后价格 = 无税开票价 * (1 - 综合折扣比例)
        this.$root.$on("loseFocus", (data)=>{
            // 扣除折扣后价格=（1-税率）*（1-开票价下浮比例）*预计中标价（纯销意见）*（1-综合折扣比例）
            // 预计开票价=纯销的中标价* （1-开票价下浮比例)
            // 无税开票价 = 开票价*（1-税率）
            if(data.row[data.prop]){
                if(data.prop == "adviseBidPrice"){
                    
                    for(let tax of this.taxList){
                        if(tax.materialCode == data.row.materialCode){
                        
                            let taxField = "nextYearTaxRate";
                            //开票价=中标价/（1+开票价下浮比例）
                            //data.row.invoicePrice = parseFloat(data.row.adviseBidPrice*(1-data.row.invoicePriceDownRatio/100)).toFixed(2); 
                            data.row.invoicePriceTemp = (data.row.adviseBidPriceTemp?data.row.adviseBidPriceTemp:data.row.adviseBidPrice)/(1+(data.row.invoicePriceDownRatioTemp?data.row.invoicePriceDownRatioTemp:data.row.invoicePriceDownRatio)/100); 
                            data.row.invoicePrice = parseFloat(data.row.invoicePriceTemp).toFixed(2);
                            // 无税开票价=开票价/(1+销项税-商品类税率）  
                            //data.row.taxlessInvoicePrice = parseFloat((data.row.invoicePrice * (1-tax[taxField])).toFixed(2));
                            data.row.taxlessInvoicePriceTemp = (data.row.invoicePriceTemp?data.row.invoicePriceTemp:data.row.invoicePrice) / (1+tax[taxField]);
                            data.row.taxlessInvoicePrice = parseFloat((data.row.taxlessInvoicePriceTemp).toFixed(2));

                            //综合折扣后价格=无税开票价*（1-综合折扣率）
                            data.row.priceAfterDiscount = parseFloat((data.row.taxlessInvoicePriceTemp*(1-data.row.comprehensiveDiscountRatio/100)).toFixed(2));
                            break;
                        }
                    }
                }
                
            }

            // 实时保存数据
            this.saveInfo()
        });
    },
    methods: {
        // 产品类型
        changeType(val){
            this.loading=true
            this.$emit('changePureSaleList',val)
        },
           
        //需要编辑的加上类
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            column.index = columnIndex;
            let classname = "";
            if (this.editField.indexOf(column.property) != -1) {
                if (
                    R.isNil(row[column.property]) ||
                    R.isEmpty(row[column.property]) ||
                    row[column.property].length == 0
                ) {
                    classname += " placeholder-color";
                } else {
                    classname += " normal-color";
                }
                classname += " edit";
                return classname;
            }
            if( column.property == "sfSales" && row.sfSales == "0" ){
                return "cellFocus";
			}
        },
        // 编辑某一列
        celledit(row, column, cell, event) {},
        // 失去焦点
        loseFocus(e) {},
        // 关闭弹窗  0 取消  1 保存
        close(value){
            if(value==1){
                // 保存
                this.saveInfo(1)
            }

            this.dialogVisible=false
            this.$emit("closeOpinion",false)
        },
        //保存列表信息
        saveInfo(val){
            this.addParam.list = this.opinionData;
            salesApi.addPureSale(this.addParam).then(res => {
                if(res.msgCode == '100') {
                    if(val){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                }
            });
        },
    }, 
    
    beforeDestroy() {
        this.$root.$off("loseFocus");
    },
};
</script>

<style lang="scss" scoped>
.opinion{
    margin-bottom: 20px;
}
.header .title{
    font-size: 18px;
    color: #323232;
}
.header .title span{
	color: #ff7901;
}
.filter{
    margin-top: 30px;
}
.filterTitle{
    margin-right: 10px;
	font-size: 14px;
	color: #323232;
}
// 统一页面 el-button按钮大小
.el-button {
    padding: 8px 14px;
}
/deep/.el-dialog{
    position: relative;
    margin-top: 10vh !important;
    height: 80%;
}

/deep/.el-dialog__headerbtn{
    display: none;
}
/deep/.el-dialog__body{
    padding-top: 0;
    height: 80%;
}
/deep/.el-input--prefix .el-input__inner{
    padding-left: 0 !important;
    padding-right: 0 !important;
}
/deep/.el-dialog .el-table--border tr .edit .cell .el-input .el-input__inner, .el-dialog .el-table tr .edit .cell .el-input .el-input__inner{
    height: 40px !important;
    
    border: 0px solid #dcdfe6 !important;
    border-radius: 0px !important;
    text-align: center !important;
}
/deep/.el-table tr .cellFocus{
    color:#ff1111
}
/deep/.el-table .cell{
    padding-left: 0 !important;
    padding-right:0  !important;
}
</style>